var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4763_2339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10H3C1.343 10 0 11.343 0 13V21C0 22.657 1.343 24 3 24H7C8.657 24 10 22.657 10 21V13C10 11.343 8.657 10 7 10ZM3.5 21H3C2.448 21 2 20.552 2 20C2 19.448 2.448 19 3 19H3.5C4.052 19 4.5 19.448 4.5 20C4.5 20.552 4.052 21 3.5 21ZM3.5 18H3C2.448 18 2 17.552 2 17C2 16.448 2.448 16 3 16H3.5C4.052 16 4.5 16.448 4.5 17C4.5 17.552 4.052 18 3.5 18ZM7 21H6.5C5.948 21 5.5 20.552 5.5 20C5.5 19.448 5.948 19 6.5 19H7C7.552 19 8 19.448 8 20C8 20.552 7.552 21 7 21ZM7 18H6.5C5.948 18 5.5 17.552 5.5 17C5.5 16.448 5.948 16 6.5 16H7C7.552 16 8 16.448 8 17C8 17.552 7.552 18 7 18ZM7 15H3C2.448 15 2 14.552 2 14C2 13.448 2.448 13 3 13H7C7.552 13 8 13.448 8 14C8 14.552 7.552 15 7 15ZM24 3C24 3.552 23.552 4 23 4H11C10.448 4 10 3.552 10 3V2.5C10 1.576 9.72 0.716 9.24 0H21C22.657 0 24 1.343 24 3ZM21 6V20C21 22.209 19.209 24 17 24H10.997C11.626 23.164 12 22.125 12 21V13C12 10.243 9.757 8 7 8H3V2.643C3 1.335 3.941 0.143 5.242 0.013C6.738 -0.137 8 1.034 8 2.5V3C8 4.657 9.343 6 11 6H21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4763_2339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorBill);
export default __webpack_public_path__ + "static/media/calculator-bill.1baa614d8112ba8df43fded4a5a6996f.svg";
export { ForwardRef as ReactComponent };